<template>
  <v-dialog :model-value="modelValue" max-width="400" @update:model-value="$emit('update:modelValue', $event)">
    <v-card>
      <v-card-title class="text-h6 py-4">{{ title }}</v-card-title>
      <v-card-text class="text-body-1">{{ message }}</v-card-text>
      <v-card-actions class="pa-4">
        <v-spacer />
        <v-btn variant="text" @click="$emit('update:modelValue', false)">{{ cancelText || $t('general.cancel') }}</v-btn>
        <v-btn :color="confirmColor" :loading="loading" @click="$emit('confirm')">
          {{ confirmText || $t('general.delete') }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
/**
 * The recurring "are you sure you want to delete X?" dialog - one place to
 * change how every confirm/delete prompt in the app looks or behaves.
 *
 * Usage:
 *   <ConfirmDialog
 *     v-model="deleteDialog"
 *     :title="`${$t('suppliers.removeComponent')}?`"
 *     :message="$t('suppliers.removeComponentConfirm', { name: item?.name })"
 *     :loading="deleting"
 *     @confirm="doDelete"
 *   />
 */
export default {
  name: 'ConfirmDialog',

  props: {
    modelValue: {
      type: Boolean,
      default: false
    },
    title: {
      type: String,
      default: ''
    },
    message: {
      type: String,
      default: ''
    },
    loading: {
      type: Boolean,
      default: false
    },
    confirmColor: {
      type: String,
      default: 'error'
    },
    confirmText: {
      type: String,
      default: undefined
    },
    cancelText: {
      type: String,
      default: undefined
    }
  },

  emits: ['update:modelValue', 'confirm']
};
</script>
